module.exports = __webpack_public_path__ + "img/pizza-hut.1171154b.png";